import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(view) {
    return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'anonymous',
            component: loadView('AnonymousPage'),
            props: {
                title: '',
                scrollToTop: true,
                type: 'anonymous',
                stats: 'Public Homepage',
                shareable: false
            }
        },
        {
            path: '/rk/:relmKey.html',
            name: 'home',
            component: loadView('LandingPage'),
            props: {
                title: '',
                scrollToTop: false,
                type: 'homepage',
                stats: 'Homepage',
                shareable: true
            }
        },
        {
            path: '/rk/:relmKey/:slug.html',
            name: 'article',
            component: loadView('ArticlePage'),
            props: {
                title: '',
                scrollToTop: true,
                type: 'article',
                stats: '',
                shareable: true
            }
        },
        {
            path: '/gk/:persona/:step.html',
            name: 'personaHome',
            component: loadView('LandingPage'),
            props: {
                title: '',
                scrollToTop: false,
                type: 'homepage',
                stats: 'Persona homepage',
                shareable: false
            }
        },
        {
            path: '*',
            name: '404',
            component: loadView('PageNotFound'),
            props: {
                title: '404 Error',
                scrollToTop: true,
                type: 'error',
                stats: '404',
                shareable: false
            }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        }
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    }
});
